module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 12h-.306l-1.72-10.328A2.003 2.003 0 0 0 26 0H6a2 2 0 0 0-1.972 1.672L2.306 12H2c-1.106 0-2 .894-2 2v10c0 1.106.894 2 2 2v3a3.001 3.001 0 0 0 6 0v-3h16v3a3.001 3.001 0 0 0 6 0v-3c1.106 0 2-.894 2-2V14c0-1.106-.894-2-2-2zM8 19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm-1.638-7l1.332-8h16.614l1.332 8H6.362zM28 19a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/car-1.js
// module id = 1047
// module chunks = 14